<template>
  <div>
    <div class="header-video">
      <img :src="loadUrl.studio_banner" />
      <div class="video-text">
        <div class="logo-text">
          <span>混空</span>
          <span>Studio</span>
        </div>
        <div class="link-room">AI+AR元宇宙内容创作与分发</div>
      </div>
    </div>
    <div class="role-wrap">
      <div class="title">专业的元宇宙智能创作工具</div>
      <div class="title-tips">智能生成数字空间&nbsp;&nbsp;智能创作工具链&nbsp;&nbsp;跨端智能互动体验</div>
      <div class="role-scene">
        <div>
          <div v-for="(item, index) in roleTextList" :class="item.activeClass" :key="index">
            <div class="role-title">{{ item.title }}</div>
            <div class="role-title-tips">{{ item.tips }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="role-wrap2">
      <div class="title">多种识别方式，更灵活、更有趣</div>
      <div class="title-tips2">单点AR服务</div>
      <div class="role-scene">
        <div>
          <div v-for="(item, index) in singlePointDataList" :key="index">
            <div class="scene-type">{{ item.name }}</div>
            <div class="scene-content">
              <img v-if="item.url" :src="item.url" />
            </div>
          </div>
        </div>
      </div>
      <div class="title-tips2">空间AR服务</div>
      <div class="role-scene2">
        <div>扫描空间特征，</div>
        <div>识别成功后，在立体空间中出现虚拟互动内容</div>
        <div class="room-pic">
          <img v-if="loadUrl.room_recognition" :src="loadUrl.room_recognition" />
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="title deep">我们的优势</div>
      <div class="title-tips deep">更低的创作门槛，更丰富的功能</div>
      <div class="m1">
        <div>
          <img class="m1-img" src="@/assets/images/studio/m1-l.png" />
          <div class="t1">更准确的空间定位</div>
          <div class="t2">自研空间定位算法，厘米级视觉定位空间导航精准， 支持大空间定位</div>
        </div>
        <div>
          <img src="@/assets/images/studio/m1-r.png" />
          <div class="t1">更快速的交付部署</div>
          <div class="t2">SaaS化服务快速调整内容布局2天内完成空间构建现场体验式交付</div>
        </div>
      </div>
      <div class="m2">
        <img class="img2" src="@/assets/images/studio/m2-l.png" />
        <img class="img1" src="@/assets/images/studio/m2-m.png" />
        <img class="img3" src="@/assets/images/studio/m2-r.png" />
        <div class="t1">更简单的场景创作</div>
        <div class="t2">3D场景地图，可视化交互智能创作，所“建”即所得</div>
      </div>
      
      <div class="m4">
        <img class="img2" src="@/assets/images/studio/m4tupian1.png" />
        <img class="img1" src="@/assets/images/studio/m4tupian.png" />
        <div class="t1">AI创作功能</div>
        <div class="t2">AI一键生成内容素材，畅享无限创作</div>
      </div>
      
      <div class="m3">
        <div>
          <div class="m3-icons">
            <img src="@/assets/images/studio/m3-l-1.png" />
            <img src="@/assets/images/studio/m3-l-2.png" />
            <img src="@/assets/images/studio/m3-l-3.png" />
          </div>
          <div class="t1">更多平台支持应用</div>
          <div class="t2">XR/VR眼镜、移动端APP、小程序AR、Web AR</div>
        </div>
        <div>
          <div class="m3-r">
            <img src="@/assets/images/studio/m3-r-t.png" />
            <img src="@/assets/images/studio/m3-r-b.png" />
          </div>
          <div class="t1">更强的内容扩展性</div>
          <div class="t2">数字多媒体动画、特效手势互动、3D数字人</div>
        </div>
      </div>
    </div>
    <div class="solution">
      <div class="title">混空Studio使用教程</div>
      <div class="title-tips">AI+AR元宇宙创作智能体，轻松实现AR创作与开发</div>
      <div class="solution-content">
        <div>
          <div v-for="(item, index) in solutionBannerList" :key="index">
            <div>
              <img v-if="item.i_url" :src="item.i_url" />
              <video v-if="item.v_url" :src="item.v_url" autoplay loop muted playsinline webkit-playsinline></video>
            </div>
            <div>
              <img :src="item.a_url" />
              <span>{{ item.title }}</span>
              <div>
                <div v-for="(e, i) in item.content" :key="i">
                  <span>{{ e }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="package">
      <div>
        <div class="title deep">按需选择 灵活购买</div>
        <div class="title-tips deep">混空Studio产品体系</div>
        <div class="package-list">
          <div>
            <div class="img-div">

              <div class="header">
                <div>空间AR服务</div>
              </div>

              <div class="content">
                <div class="suv-title2">标准服务包含</div>
                <div class="service-content">
                 
                    <span>定位面积</span>
                    <span>服务时长</span>
                    <span>并发数量</span>
                    <span>作品数量</span>
                    <span>小程序访问次数</span>
                    <span>素材空间容量</span>
                
                </div>
                <div class="suv-title2" style="font-size: 20rem;">功能包含</div>
                <div class="function-box">
                  <div>全平台空间定位功能</div>
                  <div>XR眼镜端</div>
                  <div>移动端</div>
                  <div>微信小程序</div>
                </div>
              </div>

              <div class="footer">
                <div class="contact-btn" @click="router.push('/counselling')">立即咨询</div>
                <div class="contact-tips">可根据您的作品实际情况，购买标准服务(支持按需扩展单项)，详询混空商务</div>
              </div>
              
              
            </div>
            <div class="img-div">

              <div class="header">
                <div>单点AR服务</div>
              </div>
              
              <div class="content">
                
                <div class="suv-title2">标准服务包含</div>
                <div class="service-content">
                    <span>单点AR识别</span>
                    <span>服务时长</span>
                    <span>作品数量</span>
                    <span>小程序访问次数</span>
                    <span>素材空间容量</span>
                </div>
                
                <div class="suv-title2" style="font-size: 20rem;">功能包含</div>
                <div class="function-box">
                  <div>平面AR</div>
                  <div>图像AR</div>
                  <div>单场景AR</div>
                  <div>人脸AR</div>
                  <div>身体AR</div>
                  <div>手势AR</div>
                </div>
              </div>

              <div class="footer">                
                <div class="contact-btn" @click="router.push('/counselling')">立即咨询</div>
                <div class="contact-tips">可根据您的作品实际情况，购买标准服务(支持按需扩展单项)，详询混空商务</div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, watch, onUnmounted } from 'vue';
import { asynchronousRetrieval } from '@/utils';
import router from '@/router';
const loadUrl: any = ref({})
const activeRoleIndex = ref(0)
const singlePointDataList = ref([
  {
    name: '平面AR',
    url: ''
  },
  {
    name: '图像AR',
    url: ''
  },
  {
    name: '单场景AR',
    url: ''
  },
  {
    name: '身体AR',
    url: ''
  },
  {
    name: '人脸AR',
    url: ''
  },
  {
    name: '手势AR',
    url: ''
  }
]);
const roleTextList = ref(
  [
    {
      title: '构建AR大场景',
      tips: 'SAAS化部署，无缝开发沉浸式世界里的增强现实内容，所有这些都在您的网络浏览器中创建和部署',
      url: require('@/assets/images/home/room-platform.png'),
      activeClass: 'room-bg'
    },
    {
      title: 'XR眼镜端',
      tips: '通过账号进行登陆并选择相应场景进入相关展示内容。根据现场虚与实的融合进行体验',
      url: require('@/assets/images/home/ar-rokid.png'),
      activeClass: 'glass-bg'
    },
    {
      title: '移动端',
      tips: '游客模式使用移动端混空Studio\nAPP或混空微信小程序进行空间互动体验(设备需支持ARkit/ARcore)。',
      url: loadUrl.value.web_platform,
      activeClass: 'web-bg'
    }
  ]
)
const solutionBannerList: any = ref(
  [
    {
      title: '空间数字化建图',
      content: ['多源采集：支持多种采集设备', '自研VPS定位：实现厘米级视觉定位精度'],
      url: require('@/assets/images/studio/solution-l-icon1.png'),
      a_url: require('@/assets/images/studio/solution-l-icon1A.png'),
    },
    {
      title: '智能场景创作',
      content: ['虚拟空间装修：', '3D 模型 / 动画 / 数字人', '交互逻辑一站式配置'],
      url: require('@/assets/images/studio/solution-l-icon2.png'),
      a_url: require('@/assets/images/studio/solution-l-icon2A.png'),
    },
    {
      title: '跨端部署',
      content: ['多形态交付：智能眼镜、手机等多端部署', '实时数据同步：可远程更新，内容动态迭代'],
      url: require('@/assets/images/studio/solution-l-icon3.png'),
      a_url: require('@/assets/images/studio/solution-l-icon3A.png'),
    },
    {
      title: '数实融合体验',
      content: ['多端体验数实融合互动场景'],
      url: require('@/assets/images/studio/solution-l-icon4.png'),
      a_url: require('@/assets/images/studio/solution-l-icon4A.png'),
    }
  ]
)

onMounted(async () => {
  const studio_banner: any = await asynchronousRetrieval('webimg/images/vps-img2.png');
  const web_platform: any = await asynchronousRetrieval('webimg/images/home/web-platform.png');
  const collect_maps: any = await asynchronousRetrieval('webimg/video/collect-maps.gif');
  const creating_scenes: any = await asynchronousRetrieval('webimg/video/creating-scenes.gif');
  const rapid_deployment: any = await asynchronousRetrieval('webimg/images/studio/rapid-deployment.png');
  const virtual_real_fusion: any = await asynchronousRetrieval('webimg/gif/virtual-real-fusion.gif');
  const glass_platform_bg: any = await asynchronousRetrieval('webimg/images/home/glass_platform_bg.png');
  const plane_recognition: any = await asynchronousRetrieval('webimg/images/studio/plane-recognition.gif');
  const hand_recognition: any = await asynchronousRetrieval('webimg/images/studio/hand-recognition.gif');
  const single_scene: any = await asynchronousRetrieval('webimg/images/studio/single-scene.gif');
  const body_recognition: any = await asynchronousRetrieval('webimg/images/studio/body-recognition.gif');
  const image_recognition: any = await asynchronousRetrieval('webimg/images/studio/image-recognition.gif');
  const face_recognition: any = await asynchronousRetrieval('webimg/images/studio/face-recognition.gif');
  const room_recognition: any = await asynchronousRetrieval('webimg/gif/room.gif');
  loadUrl.value = { studio_banner, web_platform, collect_maps, creating_scenes, rapid_deployment, virtual_real_fusion, glass_platform_bg, room_recognition }

  roleTextList.value[2].url = web_platform
  solutionBannerList.value[0].i_url = collect_maps
  solutionBannerList.value[1].i_url = creating_scenes
  solutionBannerList.value[2].i_url = rapid_deployment
  solutionBannerList.value[3].i_url = virtual_real_fusion
  singlePointDataList.value[0].url = plane_recognition;
  singlePointDataList.value[1].url = image_recognition;
  singlePointDataList.value[2].url = single_scene;
  singlePointDataList.value[3].url = body_recognition;
  singlePointDataList.value[4].url = face_recognition;
  singlePointDataList.value[5].url = hand_recognition;
})
</script>
<style scoped lang="less">
.header-video {
  position: relative;
  width: 100%;
  height: 336rem;
  position: relative;
  background-size: 100% 100%;
  background: #3b8dd1;

  img {
    height: 100%;
    object-fit: fill;
    position: absolute;
    right: 0;
    top: 0;
  }

  .video-text {
    width: 1120rem;
    position: absolute;
    top: 114rem;
    left: 62rem;
    font-size: 20rem;
    color: #FFFFFF;
    text-align: left;

    .logo-text {
      font-weight: 600;
      font-size: 40rem;
      color: #FFFFFF;
    }

    .link-room {
      font-size: 24rem;
      color: #FFFFFF;
      margin-top: 10rem;
    }

    .experience-now {
      margin-top: 58rem;
      width: 160rem;
      height: 50rem;
      background: #0675FF;
      border-radius: 25rem;
      padding: 0 6rem 0 16rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      color: #fff;
      font-size: 24rem;

      .experience-btn {
        width: 38rem;
        height: 38rem;
        background: url(~@/assets/images/next-icon.png);
        background-size: 100% 100%;
      }
    }
  }
}

.role-wrap {
  width: 100vw;
  background: #242424;
  padding-top: 64rem;

  .title {
    font-weight: bold;
    font-size: 40rem;
    color: #FFFFFF;
    margin-bottom: 4rem;
  }

  .title-tips {
    font-weight: 400;
    font-size: 24rem;
    color: #FFFFFF;
    margin-bottom: 40rem;
  }

  .title-tips2 {
    font-weight: 400;
    font-size: 32rem;
    color: #FFFFFF;
    margin: 40rem 0 26rem;
  }

  .role-scene {
    width: 100%;
    overflow: hidden;
    overflow-x: auto;

    &>div {
      width: 1840rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 36rem 0;

      &>div {
        width: 600rem;
        height: 494rem;
        background-image: url(~@/assets/images/studio/AR-platform-m.png);
        background-size: 100% 100%;
        padding: 40rem 70rem;
        box-sizing: border-box;
        text-align: left;

        .role-title {
          font-weight: bold;
          font-size: 32rem;
          color: #FFFFFF;
          margin-bottom: 12rem;
        }

        .role-title-tips {
          font-weight: 400;
          font-size: 24rem;
          color: #FFFFFF;
          line-height: 36rem
        }
      }

      .glass-bg {
        background-image: url('@/assets/images/studio/VR-platform-m.png');
        background-size: 100% 100%;
      }

      .web-bg {
        background-image: url(~@/assets/images/studio/web-platform-m.png);
        background-size: 100% 100%;
      }
    }
  }
}

.role-wrap2 {
  width: 100vw;
  background: #242424;
  padding-top: 64rem;
  padding-bottom: 40rem;

  .title {
    font-weight: bold;
    font-size: 40rem;
    color: #FFFFFF;
    margin-bottom: 4rem;
  }

  .title-tips {
    font-weight: 400;
    font-size: 24rem;
    color: #FFFFFF;
    margin-bottom: 40rem;
  }

  .title-tips2 {
    font-weight: 400;
    font-size: 32rem;
    color: #FFFFFF;
    margin: 40rem 0 26rem;
  }

  .role-scene {
    width: 100%;
    overflow: hidden;
    overflow-x: auto;

    &>div {
      width: 3016rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 36rem 0;
      box-sizing: border-box;

      &>div {
        width: 474rem;
        height: 814rem;
        padding: 45rem 48rem;
        box-sizing: border-box;
        text-align: left;
        background: #1B1B1B;
        border-radius: 24rem;
        border: 2px solid rgba(255,255,255,0.2);
        font-weight: bold;
        font-size: 32rem;
        color: #FFFFFF;

        .scene-content {
          width: 360rem;
          height: 642rem;
          border-radius: 16rem;
          overflow: hidden;
          margin-top: 28rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }

  .role-scene2 {
    width: 678rem;
    height: 560rem;
    background: #1B1B1B;
    border-radius: 24rem;
    border: 2px solid rgba(255,255,255,0.2);
    margin-left: 36rem;
    padding: 36rem 66rem 16rem;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 24rem;
    color: #FFFFFF;
    text-align: left;
    line-height: 1.5;

    .room-pic {
      position: relative;
      width: 544rem;
      height: 406rem;
      margin-top: 26rem;
      overflow: hidden;
      border-radius: 24rem;

      img {
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
}

.advantage {
  background: linear-gradient(180deg, #FFFFFF 0%, #E9EFF6 100%);
  padding-top: 64rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  color: #000000;

  .title {
    font-weight: bold;
    font-size: 40rem;
  }

  .title-tips {
    margin: 5rem 0 30rem;
    font-size: 24rem;
  }

  .m1 {
    width: 680rem;

    &>div:first-child {
      width: 100%;
      height: 344rem;
      background: #1F2A34;
      border-radius: 24rem;
      position: relative;
      font-weight: 500;
      padding: 238rem 0 0 38rem;
      box-sizing: border-box;
      overflow: hidden;

      img {
        width: 369rem;
        position: absolute;
        left: 154rem;
        top: 28rem;
        transition: all 1s;
      }

      &>div {
        position: relative;
        z-index: 1;
        text-align: left;
      }

      &>div.t1 {
        font-size: 28rem;
        color: #FFFFFF;
      }

      &>div.t2 {
        font-size: 20rem;
        color: #C0C0C0;
        margin-top: 7rem;
      }

      &::after {
        content: '';
        width: 406rem;
        height: 161rem;
        background: linear-gradient(180deg, rgba(31, 42, 52, 0) 0%, rgba(31, 42, 52, 0.95) 50%, #1F2A34 100%);
        border-radius: 24rem;
        position: absolute;
        left: 136rem;
        top: 136rem;
      }
    }

    &>div:last-child {
      width: 680rem;
      height: 292rem;
      background: #FFFFFF;
      border-radius: 32rem;
      position: relative;
      padding: 188rem 0 0 38rem;
      box-sizing: border-box;
      font-weight: 500;
      text-align: left;
      margin: 16rem 0;

      img {
        width: 350rem;
        height: 144rem;
        position: absolute;
        top: 20rem;
        left: 142rem;
      }

      .t1 {
        font-size: 28rem;
        color: #000000;
        margin-bottom: 8rem;
      }

      .t2 {
        font-size: 20rem;
        color: #7F7F7F;
      }
    }
  }

  .m2 {
    width: 680rem;
    height: 348rem;
    background: url('@/assets/images/studio//m2-bg.png');
    background-size: 100% 100%;
    position: relative;
    padding: 242rem 0 0 38rem;
    font-weight: 500;
    box-sizing: border-box;
    text-align: left;
    overflow: hidden;
    margin-bottom: 16rem;

    .img1 {
      width: 501rem;
      height: 208rem;
      position: absolute;
      top: 22rem;
      left: 90rem;
      transition: all 1s;
    }

    .img2 {
      width: 86rem;
      height: 132rem;
      position: absolute;
      left: 42rem;
      top: 110rem;
      z-index: 1;
      transition: all 1s;
    }

    .img3 {
      position: absolute;
      width: 134rem;
      height: 124rem;
      top: 138rem;
      right: 54rem;
      transition: all 1s;
    }

    .t1 {
      font-size: 28rem;
      color: #FFFFFF;
      margin-bottom: 8rem;
    }

    .t2 {
      font-size: 20rem;
      color: #C0C0C0;
    }
  }

  .m4 {
    width: 680rem;
    height: 348rem;
    background: #fff;
    background-size: 100% 100%;
    position: relative;
    padding: 242rem 0 0 38rem;
    font-weight: 500;
    box-sizing: border-box;
    text-align: left;
    overflow: hidden;
    margin-bottom: 16rem;
    border-radius: 24rem;

    .img1 {
      width: 377rem;
    height: 262rem;
    position: absolute;
    top: 35rem;
    left: 151rem;
      transition: all 1s;
    }

    .img2 {
          width: 635rem;
    height: 255rem;
    position: absolute;
    left: 23rem;
    top: 1rem;
      z-index: 1;
      transition: all 1s;
    }

    .t1 {
      font-size: 28rem;
      color: #000000;
      margin-bottom: 8rem;
    }

    .t2 {
      font-size: 20rem;
      color: #7F7F7F;
    }
  }

  .m3 {
    text-align: left;

    &>div {
      width: 680rem;
      height: 348rem;
      padding: 242rem 0 0 38rem;
      box-sizing: border-box;
      font-weight: 500;
      margin-bottom: 16rem;

      .t1 {
        font-size: 28rem;
        margin-bottom: 8rem;
      }
    }

    &>div:first-child {
      position: relative;
      background: #FFFFFF;
      border-radius: 24rem;

      .t1 {
        font-size: 28rem;
        color: #000000;
      }

      .t2 {
        font-size: 20rem;
        color: #7F7F7F;
      }
    }

    &>div:last-child {
      background: url(~@/assets/images/studio/m3-r-bg.png);
      background-size: 100% 100%;
      position: relative;
      overflow: hidden;

      .t1 {
        font-size: 28rem;
        color: #fff;
      }

      .t2 {
        font-size: 20rem;
        color: #C0C0C0;
      }
    }

    .m3-icons {
      width: 380rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      left: 52rem;
      top: 46rem;

      img {
        width: 172rem;
        margin-right: 24rem;
      }
    }

    .m3-r {
      position: relative;
      position: absolute;
      top: 0;
      left: 0;

      img {
        width: 680rem;
        height: 63rem;
        display: inline-block;
        position: absolute;
      }

      &>img:first-child {
        top: 34rem;
        left: 56rem;
      }

      &>img:last-child {
        top: 120rem;
        left: -63rem;
      }
    }
  }
}

.solution {
  padding: 72rem 0 68rem;
  background-color: rgba(13, 13, 13, 0.9);

  .title {
    font-weight: 500;
    font-size: 40rem;
    color: #FFFFFF;
    margin-bottom: 4rem;
  }

  .title-tips {
    font-weight: 500;
    font-size: 24rem;
    color: #FFFFFF;
    margin-bottom: 60rem;
  }

  .solution-content {
    width: 100%;
    overflow: hidden;
    overflow-x: auto;

    &>div {
      width: 2352rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 80rem;

      &>div {
        position: relative;
        width: 552rem;
        overflow: hidden;
        border-radius: 20rem;

        &>div:first-child {
          border-radius: 7rem;
          overflow: hidden;
        }

        &>div {
          height: 380rem;

          video {
            width: 100%;
            height: 380rem;
            object-fit: fill;
            position: absolute;
            right: 0;
            top: 0;
            border-radius: 20rem;
          }

          img {
            width: 100%;
            height: 380rem;
          }
        }
      }

      &>div>div:last-child {
        height: 286rem;
        margin-top: -28rem;
        padding-top: 82rem;
        box-sizing: border-box;
        background-color: #181818;

        img {
          width: 48rem;
          height: auto;
          vertical-align: middle;
        }

        &>span {
          font-weight: 500;
          font-size: 32rem;
          color: #FFFFFF;
          vertical-align: middle;
        }

        &.no-list>div:not(.line) {
          padding-left: 38rem;
        }

        &.no-list>div:not(.line)>div::before {
          content: none;
        }

        &>div:not(.line) {
          position: relative;
          text-align: center;
          margin-top: 8rem;
          font-weight: 400;
          font-size: 24rem;
          line-height: 44rem;
          // padding-left: 68rem;

          &>div {
            position: relative;
          }

          &>div>span {
            position: relative;
          }
        }

        &>div {
          font-weight: 400;
          color: #7F7F7F;
        }
      }
    }
  }
}

.package {
  width: 100vw;
  height: 988rem;
  background: linear-gradient( 180deg, #FFFFFF 0%, #E9EFF6 100%);

  &>div {
    padding-top: 72rem;

    .title {
      font-weight: 600;
      font-size: 40rem;
      color: #000000;
      line-height: 56rem;
      margin-bottom: 14rem;
    }

    .title-tips {
      font-weight: 500;
      font-size: 24rem;
      color: #5C5C5C;
      line-height: 34rem;
    }
  }

  .package-list {
    width: 100vw;
    margin-top: 30rem;
    overflow: hidden;
    overflow-x: auto;

    &>div {
      width: 1216rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 80rem;
      box-sizing: border-box;
      
      .img-div {

    
        position: relative;
        width: 514rem;
        height: 750rem;
        background: rgba(255,255,255,0.32);
        box-shadow: 0rem 4rem 20rem 0rem rgba(0,0,0,0.06);
        border-radius: 24rem;
        border: 1px solid rgba(0,0,0,0.1);
        padding: 32rem;
        box-sizing: border-box;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        gap: 5rem;


        .header {
          font-weight: 500;
          font-size: 32rem;
          color: #000000;
          text-align: left;
          margin-bottom: 16rem;
        }

        .content {
          height: 100%;
        }

        .suv-title2 {
          font-weight: 500;
          font-size: 24rem;
          color: #000000;
          text-align: left;
          margin-bottom: 16rem;
        }

        .service-content {

          margin-bottom: 14rem;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          gap: 12rem;

          span {
            display:block;
            font-weight: 400;
            font-size: 20rem;
            color: #0675FF;
            text-align: center;
            padding: 6rem 11rem;
            background: rgba(6,117,255,0.1);
            border-radius: 4rem;
            word-break: keep-all;
          }
        }

        .function-box {
          font-weight: 400;
          font-size: 20rem;
          color: #4F4F4F;
          text-align: left;

          &>div {
            position: relative;
            margin-bottom: 12rem;
            padding-left: 22rem;

            &::before {
              content: '';
              width: 16rem;
              height: 16rem;
              background-image: url(~@/assets/images/studio/list-iconA.png);
              background-size: 100% 100%;
              position: absolute;
              left: 0;
              top: 4rem;
            }
          }
        }

        .contact-btn {
          width: 450rem;
          height: 76rem;
          line-height: 76rem;
          background: #0675FF;
          border-radius: 8rem;
          margin-bottom: 20rem;
          text-align: center;
          font-weight: 500;
          font-size: 23rem;
          color: #FFFFFF;
        }

        .contact-tips {
          font-weight: 400;
          font-size: 16rem;
          color: #828282;
   
          /* left: 0; */
          width: 100%;
          text-align: left;
        }
      }
    }
  }
}
</style>